/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Rendering_Event_AudioInputs */

const en_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering Event Audio`)
};

const fr_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendu audio des événements`)
};

const de_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiowiedergabe bei Ereignissen`)
};

const it_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio dell'evento di rendering`)
};

const ru_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рендеринг аудиособытий`)
};

const es_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representación de audio de eventos`)
};

const zh_cn2_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渲染事件音频`)
};

const ja_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントオーディオのレンダリング`)
};

const hi_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेंडरिंग इवेंट ऑडियो`)
};

const pt_pt2_audio_description_export_status_rendering_event_audio = /** @type {(inputs: Audio_Description_Export_Status_Rendering_Event_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderização de áudio de evento`)
};

/**
* | output |
* | --- |
* | "Rendering Event Audio" |
*
* @param {Audio_Description_Export_Status_Rendering_Event_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_rendering_event_audio = /** @type {((inputs?: Audio_Description_Export_Status_Rendering_Event_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Rendering_Event_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "de") return de_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "it") return it_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "ru") return ru_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "es") return es_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "ja") return ja_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "hi") return hi_audio_description_export_status_rendering_event_audio(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_rendering_event_audio(inputs)
	return en_audio_description_export_status_rendering_event_audio(inputs)
});